import { useEffect, useState } from "react";
import notificationIcon from "../../assets/notificationIcon.svg";
import { useAppContext } from "../../context/AppContext";
import { useNotifications } from "../../hooks/useNotifications";
import { useLocation } from "react-router-dom";

const PAGE_TITLES = {
  dashboard: "Dashboard",
  locations: "Locations",
  users: "Users",
  devices: "Devices",
  admin: "Administration",
};

const PageHeader = () => {
  const { setNotificationSliderVisible } = useAppContext();
  // const [unseenNotifications, setUnseenNotifications] = useState(0);
  const { pagination } = useNotifications({
    is_read: false,
    limit: 20,
    sort: "updated_at|desc",
  });
  const location = useLocation();

  if (location.pathname.includes("/devices/")) {
    return null;
  }

  return (
    <div className="flex justify-between items-center text-3xl md:text-4xl font-bold pb-5">
      <span>
        {PAGE_TITLES[location.pathname.split("/")[1] as never] ||
          PAGE_TITLES["dashboard"]}
      </span>
      <div
        className="flex relative pr-3 cursor-pointer"
        onClick={() => setNotificationSliderVisible(true)}
      >
        <img
          src={notificationIcon}
          alt="Notification Bell"
          className="flex relative h-11 w-auto"
        />
        {pagination.total > 0 ? (
          <div className="h-6 w-6 bg-red-700 rounded-xl absolute ml-8 mt-6 flex justify-center items-center text-white">
            <span
              className="text-xs"
              title={`${pagination.total} Unread Notifications`}
            >
              {pagination.total > 99 ? "99+" : pagination.total}
            </span>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default PageHeader;
